export {};

declare global {
    interface String {
        capitalize(): string;
        truncate(length: number): string;
        startCase(): string;
    }
}

String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
};

String.prototype.truncate = function (length: number): string {
    return this.length > length ? `${this.slice(0, length)}...` : this.toString();
};

String.prototype.startCase = function (): string {
    return this.split(' ')
        .map((x) => x.capitalize())
        .join(' ');
};
